import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import TranslateContent from './TranslateContent'
export default class Translate extends Component {

    

    render() {

        let id = this.props.match.params.id;
       
        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <TranslateContent id={id}/>
                <Footer />

            </div>


        )
    }
}
